export default `
  query cidades($estado: String!) {
    cidades(estado: $estado) {
      id
      descricao
      abreviacao
    }
  }
`;
